import { Typography } from 'antd';
import type { ReactNode } from 'react';

/** Standalone, public legal-document layout (no auth/org context needed). */
export function LegalPage({
  title,
  updated,
  children,
}: {
  title: string;
  updated: string;
  children: ReactNode;
}) {
  return (
    <div style={{ maxWidth: 820, margin: '0 auto', padding: '48px 20px 80px' }}>
      <Typography.Title level={2}>{title}</Typography.Title>
      <Typography.Paragraph type="secondary">Last updated: {updated}</Typography.Paragraph>
      <Typography>{children}</Typography>
    </div>
  );
}
